import { render, staticRenderFns } from "./IssueCard.vue?vue&type=template&id=8b3519fc&scoped=true&"
import script from "./IssueCard.vue?vue&type=script&lang=js&"
export * from "./IssueCard.vue?vue&type=script&lang=js&"
import style0 from "./IssueCard.vue?vue&type=style&index=0&id=8b3519fc&lang=scss&scoped=true&"
import style1 from "./IssueCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b3519fc",
  null
  
)

export default component.exports